export const content = {
  heading: "How can I accelerate your work today?",
  inputPlaceholder: "Enter a legal question to see Protégé in action",
  examplesLabel: "Examples of legal questions to ask",
  examples: [
    "How does Florida define residency for tax purposes?",
    "What is considered an act of moral turpitude in California?",
    "Find Virginia cases regarding military pension distribution in divorce proceedings",
    "In federal district court, how can a video be authenticated?",
    "Is registration of a trademark required to protect trademark rights under federal law?",
  ],
  termsPrefix: "Please review LexisNexis® ",
  termsLinkText: "General Terms and Conditions",
  termsLinkHref: "https://www.lexisnexis.com/en-us/terms/general/default.page",
  termsSuffix: ".",

  // Mirrors the AiPromptBar composer: a hard cap of 5000 characters on the
  // prompt, with a live "count/limit" readout that surfaces once the user
  // passes 4500, and a max-reached message at the cap.
  maxCharacterLimit: 5000,
  showCharacterCountLimit: 4500,
  maxCharacterLimitMessage:
    "You have reached the maximum number of characters allowed.",

  submitErrorMessage:
    "We couldn't continue right now. Please try again.",

  conversationQuestionLabel: "Your question",
  generatingLabel: "Generating response",
  conversationErrorMessage:
    "The service encountered a problem processing your request. Try your request again in a new conversation.",
  disclaimer:
    "This response includes AI-generated content. Please review carefully for accuracy and relevance. Unlinked legal citations are references that could not be verified within the LexisNexis® ecosystem.",
  sourcesHeading: "Sources",
  shepardsLine: "LexisNexis® content verified by Shepard's® citation check",
  ctaExploreLabel: "Explore Protégé",
  ctaExploreHref: "https://www.lexisnexis.com/en-us/products/protege.page",
  ctaDeepDiveLabel: "Deep dive into Lexis+ with Protégé",
  ctaDeepDiveHref: "https://www.lexisnexis.com/en-us/products/lexis-plus-protege.page",
};
